<template>
  <div>
            <div>
                <el-row direction="horizontal" style="margin-top: 10px;" v-if="false">
                    <el-col :span="8">
                        <el-card :style="{ 'margin-left': '10px', 'width': '210px', 'background-color': regularColor }"
                            @click.native="cardClick('申请量')">
                            <div>
                                <el-statistic :value="overviewData1.value" :title="overviewData1.title"
                                    :value-style="{ color: 'cornflowerblue' }">
                                    <template slot="prefix">
                                        <i class="el-icon-s-flag" style="color: cornflowerblue"></i>
                                    </template>
                                </el-statistic>
                            </div>
                        </el-card>
                    </el-col>

                    <el-col :span="8">
                        <el-card :style="{ 'margin-left': '10px', 'width': '210px', 'background-color': previewColor }"
                            @click.native="cardClick('就诊量')">
                            <div>
                                <el-statistic :value="overviewData2.value" :title="overviewData2.title"
                                    :value-style="{ color: 'cornflowerblue' }">
                                    <template slot="prefix">
                                        <i class="el-icon-s-flag" style="color: cornflowerblue"></i>
                                    </template>
                                </el-statistic>
                            </div>
                        </el-card>
                    </el-col>

                    <el-col :span="8">
                        <el-card :style="{ 'margin-left': '10px', 'width': '210px', 'background-color': afterColor }"
                            @click.native="cardClick('超3天未就诊')">
                            <div>
                                <el-statistic :value="overviewData3.value" :title="overviewData3.title"
                                    :value-style="{ color: 'cornflowerblue' }">
                                    <template slot="prefix">
                                        <i class="el-icon-s-flag" style="color: cornflowerblue"></i>
                                    </template>
                                </el-statistic>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>

                <div style="margin-top: 20px;">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="我管理的" name="first">
                            <manageDetail v-if="activeName == 'first'" :numType="currentType"></manageDetail>
                        </el-tab-pane>
                        <!-- <el-tab-pane label="我发起的" name="second">
                            <initiateDetail v-if="activeName == 'second'"></initiateDetail>
                        </el-tab-pane>
                        <el-tab-pane label="我收到的" name="third">
                            <receiveDetail v-if="activeName == 'third'"></receiveDetail>
                        </el-tab-pane>
                        <el-tab-pane label="我协诊的" name="four">
                            <confirmDetail v-if="activeName == 'four'"></confirmDetail>
                        </el-tab-pane> -->

                        <!-- <el-tab-pane label="协诊24小时过期" name="second">
                            <expire-detail v-if="activeName == 'second'" :numType="currentType"></expire-detail>
                        </el-tab-pane>
                        <el-tab-pane label="待管理" name="third">
                            <receiveDetail v-if="activeName == 'third'" :numType="currentType"></receiveDetail>
                        </el-tab-pane> -->
                    </el-tabs>
                </div>
            </div>
    </div>
</template>
<script>
import manageDetail from "./bloodPressureCollaborative/manageDetail.vue"
import initiateDetail from "./bloodPressureCollaborative/initiateDetail.vue"
import receiveDetail from "./bloodPressureCollaborative/receiveDetail.vue"
import confirmDetail from "./bloodPressureCollaborative/confirmDetail.vue"
import expireDetail from "./bloodPressureCollaborative/expireDetail.vue"
import {
    getCodiagTips
} from "@/api/health/Patients.js"

export default {
    components: { manageDetail, initiateDetail, receiveDetail, confirmDetail, expireDetail },
    data() {
        return {
            activeName: "first",
            consultationVisiable: false,
            overviewData1: {
                value: 0,
                title: "申请量",
            },
            overviewData2: {
                value: 0,
                title: "就诊量",
            },
            overviewData3: {
                value: 0,
                title: "超3天未就诊",
            },
            codiagTipsQuery: {
                serviceName: '高血压协诊'
            },
            regularColor: '#ECF5FF',
            previewColor: '#ffffff',
            afterColor: '#ffffff',
            currentType: '申请量'
        };
    },
    created() {
        this.getTipsMethod();
    },
    methods: {
        getTipsMethod() {
            getCodiagTips(this.codiagTipsQuery).then((res) => {
                this.listLoading = false;
                if (res.msg == "success") {
                    var data = res.data[0];
                    this.overviewData1.value = data.countCodiagApply;
                    this.overviewData2.value = data.countCodiagVisit;
                    this.overviewData3.value = data.countCodiagUnvisit;
                }
            }).catch(error => {
                console.log(error);
            });
        },
        cardClick(type) {
            if (type == '申请量') {
                this.regularColor = '#ECF5FF';
                this.previewColor = '#ffffff';
                this.afterColor = '#ffffff';
                this.currentType = '申请量';
            } else if (type == '就诊量') {
                this.regularColor = '#ffffff';
                this.previewColor = '#ECF5FF';
                this.afterColor = '#ffffff';
                this.currentType = '就诊量';
            } else if (type == '超3天未就诊') {
                this.regularColor = '#ffffff';
                this.previewColor = '#ffffff';
                this.afterColor = '#ECF5FF';
                this.currentType = '超3天未就诊';
            }
        },
        // 点击切换tab标签页事件
        handleClick(target, action) {
            console.log(target.name, action, this.$store.getters.deptLevel)
            this.activeName = target.name;
        }
    }
}
</script>